var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.severity)?_c('div',{staticClass:"ui-message ui-widget ui-corner-all",class:{'ui-messages-info': (_vm.severity === 'info'),
              'ui-messages-warn': (_vm.severity === 'warn'),
              'ui-messages-error': (_vm.severity === 'error'),
              'ui-messages-success': (_vm.severity === 'success')},attrs:{"aria-live":"polite"}},[_c('span',{staticClass:"ui-message-icon",class:_vm.getIcon()}),_vm._v(" "),_c('span',{staticClass:"ui-message-text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65e5fab3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/message.vue
// module id = /heO
// module chunks = 0